import sliceCreator from '../../index.jsx';
import {UPDATE_TENANT_USER_PASSWORD} from '../../../constants/index.jsx';
const _updateTenantUserPasswordAction = sliceCreator('UPDATE_TENANT_USER', UPDATE_TENANT_USER_PASSWORD, 'put');

const { asyncAction: updateTenantUserPasswordAction, reducer, clearData: clearUpdateTenantUserPasswordAction } = _updateTenantUserPasswordAction;

export default reducer;

export {
    updateTenantUserPasswordAction,
    clearUpdateTenantUserPasswordAction
}